import { render } from "./PpcAuthAddView.vue?vue&type=template&id=67fef241"
import script from "./PpcAuthAddView.vue?vue&type=script&lang=js"
export * from "./PpcAuthAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__